module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('h1', [_vm._v("Reset")]), _vm._v(" "), _c('p', [_vm._v("Please enter your new password.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.password.$touch()
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.credentials.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), (_vm.$v.credentials.password.$error) ? _c('span', [(!_vm.$v.credentials.password.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.password.minLength) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Email must have at least " + _vm._s(_vm.$v.credentials.password.$params.minLength.min) + " characters.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Repeat Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.repeatPassword.$touch()
      }
    },
    model: {
      value: (_vm.credentials.repeatPassword),
      callback: function($$v) {
        _vm.credentials.repeatPassword = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.repeatPassword"
    }
  }), _vm._v(" "), (_vm.$v.credentials.repeatPassword.$error) ? _c('span', [(!_vm.$v.credentials.repeatPassword.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.repeatPassword.sameAsPassword) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Passwords must be identical.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "button",
      "disabled": _vm.$v.$invalid || _vm.app.isLoading,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": function($event) {
        _vm.resetPassword()
      }
    }
  }, [_vm._v("\n\t\t\t\t\tReset Password\n\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d2694d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Reset.vue
// module id = 636
// module chunks = 1